<template>
  <div class="help shifted">
    <h1>Help</h1>
  </div>
</template>

<script>
export default {
  name: "Help"
};
</script>

<style></style>
